export const getQueryString = (search: string, query: string): string => {
  const searchObject = new URLSearchParams(search.slice(1))
  return searchObject.get(query)
}
